export default "__VITE_ASSET__NCSFxC9yx2Eis7zw8aM1Rw__"